export function newId(): string {
  return crypto.randomUUID();
}

export function nowIso(ms: number = Date.now()): string {
  return new Date(ms).toISOString();
}

export async function sha256Hex(data: string | ArrayBuffer | Uint8Array): Promise<string> {
  const bytes =
    typeof data === 'string'
      ? new TextEncoder().encode(data)
      : data instanceof Uint8Array
        ? data
        : new Uint8Array(data);
  const digest = await crypto.subtle.digest('SHA-256', bytes as BufferSource);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Deterministic RFC-4122-shaped UUID (version 8, "custom") from a SHA-256 hex
 * digest. Used so the same imported row targets the same event id on every
 * device, making cross-device re-imports idempotent.
 */
export function uuidFromHash(hex: string): string {
  const h = hex.slice(0, 32).split('');
  h[12] = '8';
  h[16] = ((parseInt(h[16], 16) & 0x3) | 0x8).toString(16);
  const s = h.join('');
  return `${s.slice(0, 8)}-${s.slice(8, 12)}-${s.slice(12, 16)}-${s.slice(16, 20)}-${s.slice(20, 32)}`;
}
